export function defaultWidgetAppearance(accentColour = '#2563eb') {
    return {
        agentBubble: {
            backgroundColour: '#ffffff',
            fontSize: 12,
            radius: 14,
            shape: 'speech',
            textColour: '#172033',
        },
        launcher: {
            backgroundColour: accentColour,
            borderColour: accentColour,
            borderStyle: 'none',
            borderWidth: 0,
            iconColour: '#ffffff',
            radius: 18,
            shape: 'rounded',
        },
        panel: {
            backgroundColour: '#f8fafc',
            borderColour: '#f8fafc',
            borderStyle: 'none',
            borderWidth: 0,
            radius: 22,
            surfaceColour: '#ffffff',
            textColour: '#172033',
        },
        visitorBubble: {
            backgroundColour: accentColour,
            fontSize: 12,
            radius: 14,
            shape: 'speech',
            textColour: '#ffffff',
        },
    };
}
export function defaultWidgetSettings(accentColour = '#2563eb') {
    return {
        accentColour,
        appearance: defaultWidgetAppearance(accentColour),
        appearanceVersion: 1,
        availabilityMode: 'contact_form',
        departmentOfflineForms: {},
        enableVisitorChatRating: false,
        hideBranding: false,
        messagePlaceholder: 'Write a message…',
        menu: {
            emailTranscript: true,
            endChat: true,
            sound: true,
            visible: true,
        },
        offlineForm: {
            buttonLabel: 'Send message',
            confirmationMessage: 'Thanks. Your message has been sent and the team will get back to you.',
            description: 'The team is currently unavailable. Leave your details and we will get back to you.',
            title: 'Leave us a message',
        },
        position: 'right',
        startButton: 'Start chat',
        startMessage: 'Tell us how we can help and the right person will reply here.',
        startTitle: 'Start a conversation',
        subtitle: 'We usually reply straight away',
        title: 'How can we help?',
    };
}
export const DEFAULT_WIDGET_SETTINGS = defaultWidgetSettings();
export function normaliseWidgetSettings(settings) {
    const accentColour = settings?.accentColour ?? DEFAULT_WIDGET_SETTINGS.accentColour;
    const defaults = defaultWidgetSettings(accentColour);
    const bubbleFontSize = settings?.appearance?.visitorBubble?.fontSize ??
        settings?.appearance?.agentBubble?.fontSize ??
        defaults.appearance.visitorBubble.fontSize;
    const bubbleRadius = settings?.appearance?.visitorBubble?.radius ??
        settings?.appearance?.agentBubble?.radius ??
        defaults.appearance.visitorBubble.radius;
    const savedBubbleShape = settings?.appearance?.visitorBubble?.shape ??
        settings?.appearance?.agentBubble?.shape ??
        defaults.appearance.visitorBubble.shape;
    const bubbleShape = savedBubbleShape === 'square' ? 'rounded' : savedBubbleShape;
    return {
        ...defaults,
        ...settings,
        appearance: {
            ...defaults.appearance,
            ...settings?.appearance,
            agentBubble: {
                ...defaults.appearance.agentBubble,
                ...settings?.appearance?.agentBubble,
                fontSize: bubbleFontSize,
                radius: bubbleRadius,
                shape: bubbleShape,
            },
            launcher: {
                ...defaults.appearance.launcher,
                ...settings?.appearance?.launcher,
                borderStyle: 'none',
                borderWidth: 0,
                shape: 'rounded',
            },
            panel: {
                ...defaults.appearance.panel,
                ...settings?.appearance?.panel,
                borderStyle: 'none',
                borderWidth: 0,
            },
            visitorBubble: {
                ...defaults.appearance.visitorBubble,
                ...settings?.appearance?.visitorBubble,
                fontSize: bubbleFontSize,
                radius: bubbleRadius,
                shape: bubbleShape,
            },
        },
        appearanceVersion: 1,
        departmentOfflineForms: Object.fromEntries(Object.entries(settings?.departmentOfflineForms ?? {}).map(([departmentId, form]) => [
            departmentId,
            { ...defaults.offlineForm, ...form },
        ])),
        menu: {
            ...defaults.menu,
            ...settings?.menu,
        },
        offlineForm: {
            ...defaults.offlineForm,
            ...settings?.offlineForm,
        },
    };
}
//# sourceMappingURL=widget-settings.js.map